import { requestLocalHub } from './localModeService';

async function read(store, discovery, path, manage = false) {
  const response = await requestLocalHub(
    store,
    discovery,
    manage ? ['control:connect', 'network:manage'] : ['control:connect'],
    { method: 'get', url: path },
  );
  return response.data;
}

async function command(store, discovery, path, data = {}) {
  const response = await requestLocalHub(
    store,
    discovery,
    ['control:connect', 'network:manage'],
    { method: 'post', url: path, data },
  );
  return response.data;
}

export function getEmergencyNetworkStatus(store, discovery) {
  return read(store, discovery, '/local/v1/network/status');
}

export function getEmergencyNetworkCapabilities(store, discovery) {
  return read(store, discovery, '/local/v1/network/capabilities');
}

export function configureEmergencyNetwork(store, discovery, configuration) {
  return command(
    store, discovery, '/local/v1/network/configure', configuration,
  );
}

export function startEmergencyNetworkTest(store, discovery) {
  return command(store, discovery, '/local/v1/network/test/start');
}

export function stopEmergencyNetworkTest(store, discovery) {
  return command(store, discovery, '/local/v1/network/test/stop');
}

export function startEmergencyNetwork(store, discovery) {
  return command(store, discovery, '/local/v1/network/emergency/start');
}

export function stopEmergencyNetwork(store, discovery) {
  return command(store, discovery, '/local/v1/network/emergency/stop');
}

export function restartEmergencyNetwork(store, discovery) {
  return command(store, discovery, '/local/v1/network/emergency/restart');
}

export function getEmergencyNetworkProfile(store, discovery) {
  return read(
    store, discovery, '/local/v1/network/emergency/profile',
  );
}

export function getEmergencyNetworkCredentials(store, discovery) {
  return read(
    store,
    discovery,
    '/local/v1/network/emergency/credentials',
    true,
  );
}

export function getEmergencyNetworkDiagnostics(store, discovery) {
  return read(store, discovery, '/local/v1/network/diagnostics', true);
}
